'use strict'
module.exports = (initialState, actionsByType) => (
  state = initialState,
  action
) => {
  const fn = actionsByType[action.type]

  if (fn) {
    return fn(state, action)
  } else {
    return state
  }
}
